import React from 'react';
import withDividerColor from '../../hoc/with-divider-color';
import styles from './actions-divider.scss';

const ActionsDivider = ({ dividerColor }) => (
  <div className={styles.divider} style={{ backgroundColor: dividerColor }} />
);

export default withDividerColor(ActionsDivider);
